module.exports = __webpack_public_path__ + "static/media/brand-refresh-logo-google-playstore.8fb8390a.svg";